/* tslint:disable */
/* eslint-disable */
/**
 * True one Services API
 * True one service for form Builder
 *
 * The version of the OpenAPI document: 4.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AlertCondition
 */
export interface AlertCondition {
    /**
     * 
     */
    type?: AlertConditionTypeEnum;
    /**
     * 
     */
    thresholdValue?: number;
    /**
     * 
     */
    thresholdDirection?: AlertConditionThresholdDirectionEnum;
    /**
     * 
     */
    trendWindowDays?: number;
    /**
     * 
     */
    trendSlopeThreshold?: number;
    /**
     * 
     */
    consecutiveCount?: number;
}


/**
 * @export
 */
export const AlertConditionTypeEnum = {
    Threshold: 'THRESHOLD',
    Trend: 'TREND',
    ConsecutiveFailures: 'CONSECUTIVE_FAILURES',
} as const;
export type AlertConditionTypeEnum = typeof AlertConditionTypeEnum[keyof typeof AlertConditionTypeEnum];

/**
 * @export
 */
export const AlertConditionThresholdDirectionEnum = {
    Above: 'ABOVE',
    Below: 'BELOW',
} as const;
export type AlertConditionThresholdDirectionEnum = typeof AlertConditionThresholdDirectionEnum[keyof typeof AlertConditionThresholdDirectionEnum];


/**
 * Check if a given object implements the AlertCondition interface.
 */
export function instanceOfAlertCondition(value: object): value is AlertCondition {
    return true;
}

export function AlertConditionFromJSON(json: any): AlertCondition {
    return AlertConditionFromJSONTyped(json, false);
}

export function AlertConditionFromJSONTyped(json: any, ignoreDiscriminator: boolean): AlertCondition {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'] == null ? undefined : json['type'],
        'thresholdValue': json['thresholdValue'] == null ? undefined : json['thresholdValue'],
        'thresholdDirection': json['thresholdDirection'] == null ? undefined : json['thresholdDirection'],
        'trendWindowDays': json['trendWindowDays'] == null ? undefined : json['trendWindowDays'],
        'trendSlopeThreshold': json['trendSlopeThreshold'] == null ? undefined : json['trendSlopeThreshold'],
        'consecutiveCount': json['consecutiveCount'] == null ? undefined : json['consecutiveCount'],
    };
}

export function AlertConditionToJSON(json: any): AlertCondition {
    return AlertConditionToJSONTyped(json, false);
}

export function AlertConditionToJSONTyped(value?: AlertCondition | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'thresholdValue': value['thresholdValue'],
        'thresholdDirection': value['thresholdDirection'],
        'trendWindowDays': value['trendWindowDays'],
        'trendSlopeThreshold': value['trendSlopeThreshold'],
        'consecutiveCount': value['consecutiveCount'],
    };
}

